import React from 'react';
import SubnavItem from '@molecules/SubnavItem';

const EditPropertiesSubnav = () => (
    <>
        <SubnavItem label="Find Properties" to="/my-icsc/properties/find" />
        <SubnavItem label="Saved Properties" to="/my-icsc/properties/saved" />
        <SubnavItem label="Listed Properties" to="/my-icsc/properties/listed" />
    </>
);

export default EditPropertiesSubnav;
